<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.edit_team_members' | translate }}</h3>

<form (ngSubmit)="updateProduct()" enctype="multipart/form-data">
  <div class="row">


                        <div class="col-3">
                        <div class="form-group">
                            <label class="form-label required-field">{{ 'MENU.DASHBOARD.partner_logo' | translate }}</label>
                            <div class="file-upload-container">
                                <input type="file" id="logoUpload" accept="image/*" (change)="onFileSelected($event)">
                                <div class="file-upload-label">
                                    <i class="fas fa-cloud-upload-alt file-upload-icon"></i>
                                    <div class="file-upload-text">{{ 'MENU.DASHBOARD.click_to_upload_logo' | translate }}</div>
                                    <div class="file-upload-text"> {{ 'MENU.DASHBOARD.drag_drop_image' | translate }}</div>
                                    <div class="form-hint">{{ 'MENU.DASHBOARD.recommended_size' | translate }}</div>
                                </div>
                            </div>

                       <div class="preview-container" *ngIf="product?.image && !previewUrl">
  <img [src]="product.image" class="logo-preview" alt="Current Logo">
  <div class="preview-actions mt-2">
    <button type="button" class="btn btn-outline btn-sm" (click)="removeCurrentLogo()">
      <i class="fas fa-trash me-1"></i> {{ 'MENU.DASHBOARD.remove_current' | translate }}
    </button>
    <div class="form-hint mt-1">{{ 'MENU.DASHBOARD.current_logo' | translate }}</div>
  </div>
</div>

                         <!-- معاينة الصورة الجديدة المختارة -->
                            <div class="preview-container" *ngIf="previewUrl">
                                <div class="preview-header">
                                    <span class="preview-title">{{ 'MENU.DASHBOARD.new_logo_preview' | translate }}</span>
                                </div>
                                <img [src]="previewUrl" class="logo-preview" alt="New Logo Preview">
                                  <div class="preview-actions mt-2">
                                <button type="button" class="btn btn-outline btn-sm" (click)="removeNewLogo()">
                                    <i class="fas fa-trash me-1"></i> {{ 'MENU.DASHBOARD.remove_new' | translate }}
                                </button>
                            </div>
                               
                            </div>

                       
                                        <!-- رسالة إذا مافيش صورة -->
                        <div class="no-preview" *ngIf="!product.image && !previewUrl">
                             <i class="fas fa-image no-preview-icon"></i>
                            <div class="form-hint">{{ 'MENU.DASHBOARD.no_logo_uploaded' | translate }}</div>
                        </div>  
                        </div>
                    </div>


 <!-- 🏷 Name -->
<div class="col-md-12">
  <div class="mb-3">
    <label class="form-label required-field">
      {{ 'MENU.DASHBOARD.name' | translate }}
    </label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="product.name"
      name="name"
      required
      #name="ngModel"
      [class.is-invalid]="name.invalid && name.touched"
    />
    <div *ngIf="name.invalid && name.touched" class="text-danger small mt-1">
      {{ 'MENU.DASHBOARD.name_required' | translate }}
    </div>
  </div>
</div>

<!-- 🏢 Job Title -->
<div class="col-md-12">
  <div class="mb-3">
    <label class="form-label required-field">
      {{ 'MENU.DASHBOARD.job_title' | translate }}
    </label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="product.job_title"
      name="job_title"
      required
      #jobTitle="ngModel"
      [class.is-invalid]="jobTitle.invalid && jobTitle.touched"
    />
    <div *ngIf="jobTitle.invalid && jobTitle.touched" class="text-danger small mt-1">
      {{ 'MENU.DASHBOARD.job_title_required' | translate }}
    </div>
  </div>
</div>


  </div>

  <!-- 💾 Submit -->
  <div class="text-start mt-3">
    <button type="submit" class="btn px-4" style="background-color: #cca44c !important; color: #fff;">
      {{ 'MENU.DASHBOARD.save_changes' | translate }}
    </button>
  </div>
</form>

  </div>
</div>
